export default "__VITE_ASSET__B8ODXxLi__"